import { Component } from '@angular/core';

import { AnnotationsService } from '../../services/annotations.service';

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-undo-annotations',
    template: `
        <button mat-icon-button matTooltip="Undo annotation" (click)="undoLastAnnotation()">
            <mat-icon svgIcon="undo-annotation"></mat-icon>
        </button>
    `,
    styleUrls: [ './annotations.component.scss' ]
})
export class UndoAnnotationsComponent  {

    constructor( private _annotationsService: AnnotationsService ) {}

    undoLastAnnotation() {
        this._annotationsService.removeLastAnnotation();
    }
}
